export const SET_MODEL_RULES = 'setModelRules';
export const SET_QUESTION_TYPES = 'setQuestionTypes';
export const SET_QUESTIONNAIRE = 'setQuestionnaire';
